import { API_ENDPOINT, API_STAGE } from '../appConfig';

let authToken = '';

export function setAuthToken(token: string) {
    authToken = token;
}

/**
 * All backend calls are RPC-style POSTs. `apiRoute` is the path (first segment
 * is the API Gateway stage); the rest of the payload is the JSON body the
 * lambda handler reads.
 */
export async function callApi(payload: Record<string, unknown>): Promise<any> {
    const apiRoute = payload.apiRoute as string;
    const url = API_ENDPOINT + '/' + apiRoute;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
    }

    const text = await response.text();
    const sanitized = text
        .replace(/: *NaN/g, ': null')
        .replace(/: *Infinity/g, ': null')
        .replace(/: *-Infinity/g, ': null');

    const data = JSON.parse(sanitized);
    // Unwrap API-Gateway/Lambda-proxy `{ body: "..." }` envelope.
    if (data.body) {
        return typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
    }
    return data;
}

/** A single Delivery Station input row (domain shape — no storage keys). */
export interface DSInputRow {
    location_id: string;
    cycle_name: string;
    utr: number | string;
}

/** Read existing DS inputs for a business + delivery date. */
export function getDSInputs(business: string, ofdDate: string): Promise<{ items: any[]; count: number }> {
    return callApi({
        apiRoute: `${API_STAGE}/ds-input`,
        business,
        ofd_date: ofdDate,
    });
}

/**
 * Save DS inputs. The backend derives the DynamoDB keys from
 * business + ofd_date + each row's location_id/cycle_name, so the UI only
 * sends domain fields.
 */
export function saveDSInputs(
    business: string,
    ofdDate: string,
    items: DSInputRow[],
): Promise<{ written: number; user: string }> {
    return callApi({
        apiRoute: `${API_STAGE}/ds-write`,
        business,
        ofd_date: ofdDate,
        items,
    });
}
